import { IQuery } from 'core-ts-types';
import { APTerm } from '../../../../../global/builders/ap_term_builder';

class PreviewAutoGeneratedTermsController {
  private terms: APTerm[];
  private termPreference: string[];
  private termCommitment: string;
  constructor(private ngTermPlanPreviewQuery: IQuery) {}
}

angular.module('capability-ng-academic-planner').component('previewAutoGeneratedTerms', {
  controller: PreviewAutoGeneratedTermsController,
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_auto_generated_terms/preview_auto_generated_terms.html',
  bindings: {
    terms: '<',
    termCommitment: '<',
    termPreference: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_auto_generated_terms/preview_auto_generated_terms.ts